import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
var Preloader = function Preloader(props) {
  return /*#__PURE__*/React.createElement('div', {
    'data-hook': props.dataHook,
    className: props.getClassName('control-preloader')
  });
};
Preloader.displayName = 'Preloader';
Preloader.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Set the preloader size and theme.
   * Sizes can be either `tiny`, `small` (default), `medium` and `large`.
   * Themes can be either `standard` (default) and `light`*/
  className: PropTypes.string
};
export default compose(Preloader);